import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CircleCheck as CheckCircle2, Circle as XCircle, Loader as Loader2, FlaskConical } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useCart } from "@/lib/cart";
import { api } from "@/lib/api";
import { Totals } from "@/pages/Checkout";

export function PaymentReturn() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const { clear } = useCart();
  const [res, setRes] = useState(null);
  const tries = useRef(0);
  const pid = sp.get("payment_id");
  useEffect(() => {
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.post(`/payments/${pid}/verify`);
        if (data.status === "pending" && tries.current++ < 15) { timer = setTimeout(poll, 2000); return; }
        if (data.status === "confirmed" || data.status === "under_review") clear();
        setRes(data);
      } catch { setRes({ status: "failed" }); }
    };
    poll();
    return () => clearTimeout(timer);
  }, [pid]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!res) return <div className="container-x py-24 text-center space-y-3"><Loader2 className="w-10 h-10 mx-auto animate-spin text-[#2563EB]" /><p className="muted">{t("payment.verifying")}</p></div>;
  const ok = res.status === "confirmed" || res.status === "under_review";
  return (
    <div className="container-x py-16 max-w-xl" data-testid="payment-result">
      <div className="card p-8 text-center space-y-4">
        {ok ? <CheckCircle2 className="w-14 h-14 mx-auto text-[#16A34A]" /> : <XCircle className="w-14 h-14 mx-auto text-[#DC2626]" />}
        <h1 data-testid="payment-result-title" className="text-2xl font-bold">{t(ok ? "payment.success_title" : res.status === "pending" ? "payment.pending_title" : "payment.failed_title")}</h1>
        {res.mode === "test" && <p className="chip bg-amber-100 text-amber-800 mx-auto"><FlaskConical className="w-3.5 h-3.5" />{t("payment.test_label")}</p>}
        {res.order && <p className="muted">{t("payment.order_number")}: <b data-testid="order-number" className="text-[#111827] font-display">{res.order.order_number}</b></p>}
        <p className="text-sm muted">{t(ok ? "payment.success_sub" : "payment.failed_sub")}</p>
        {res.order && <div className="text-start border-t border-[#E5E7EB] pt-4"><Totals q={{ ...res.order, discount_total: 0, vat_pct: 15 }} /></div>}
        <div className="flex flex-wrap gap-3 justify-center pt-2">
          {ok ? <Link to="/track" className="btn-primary">{t("nav.track")}</Link> : <Link to="/checkout" className="btn-primary">{t("payment.retry")}</Link>}
          <Link to="/" className="btn-ghost">{t("payment.back_home")}</Link>
        </div>
      </div>
    </div>
  );
}
